import React from 'react';
const points = [{
  num: '01',
  title: 'Domenica pomeriggio = Blocco.',
  desc: "Sacrifichi il riposo cercando l'ispirazione per il lunedì mattina."
}, {
  num: '02',
  title: 'Mancanza di continuità.',
  desc: 'Senti che le tue lezioni sono "casuali" anziché un percorso pedagogico serio.'
}, {
  num: '03',
  title: 'Allieve in "stallo".',
  desc: 'Hai bisogno di nuovi stimoli per far progredire la loro flessibilità e forza.'
}, {
  num: '04',
  title: 'Desiderio di eccellenza.',
  desc: "Vuoi essere l'insegnante nota per la profondità, la musica e la fluidità delle sue classi."
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-163">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-164"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-165">
        <div className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-167">
            👀 Riconosci queste scene?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-168">
            Yoga Pronta è per te se vivi questo:
          </p>
        </div>

        <div className="space-y-4" data-id="element-169">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-lg" data-id="element-170">
              <span className="text-primary font-black text-2xl sm:text-3xl flex-shrink-0 leading-none mt-0.5" data-id="element-171">
                {point.num}
              </span>
              <div data-id="element-172">
                <h3 className="text-text-main text-lg sm:text-xl font-bold mb-1.5" data-id="element-173">
                  {point.title}
                </h3>
                <p className="text-text-sec text-base font-medium leading-relaxed" data-id="element-174">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-text-main font-bold text-lg sm:text-xl mt-10" data-id="element-175">
          ✋ Ti sei riconosciuta?{' '}
          <span className="text-primary" data-id="element-176">Allora questo Kit è per te.</span>
        </p>
      </div>
    </section>;
}